import ListSection from './components/ListSection'
import CategoryItemList from './components/CategoryItemList'
import NavBar from './components/NavBar'
import NeededItemEntry from './components/NeededItemEntry'
import NeededItemQuickEditor from './components/NeededItemQuickEditor'
import AmountCents from './components/AmountCents'
import MealToNeededPicker from './components/MealToNeededPicker'

export default {
  install (Vue, options) {
    Vue.component('nav-bar', NavBar)
    Vue.component('list-section', ListSection)
    Vue.component('category-items', CategoryItemList)
    Vue.component('needed-item-entry', NeededItemEntry)
    Vue.component('item-quick-editor', NeededItemQuickEditor)
    Vue.component('amt-cents', AmountCents)
    Vue.component('meal-ingredient-picker', MealToNeededPicker)
  }
}
